/**
 * Deterministic accent color for a profile, derived from its id (or label).
 * Profiles have no stored color in the v0.2 data model, so we hash to a stable
 * hue — the same profile always gets the same dot color, with no schema change.
 */

/** A stable HSL color string for a profile seed (id preferred). */
export function profileColor(seed: string): string {
  let hash = 0;
  for (let i = 0; i < seed.length; i += 1) {
    hash = (hash * 31 + seed.charCodeAt(i)) >>> 0;
  }
  const hue = hash % 360;
  // Fixed saturation/lightness read well in both light and dark themes.
  return `hsl(${hue} 62% 52%)`;
}
